import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountClosePage} from 'features/loans/pages/LoanAccountClosePage/LoanAccountClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/close/confirm',
)({
  component: LoanAccountClosePage,
});
